import React, { memo } from 'react';
import CMS from 'shared/routes/CMS';

function Explore() {
  return <CMS pageId="explore-app" />;
}

export default memo(Explore);
